<app-lov-value-select-filter
        (selectionChangeEvent)="singleSelectionChangedEvent.emit($event)"
        lovListName="PERSON_TITLE" [parentFormGroup]="parentFormGroup" [parentFormControlName]="parentFormControlName"></app-lov-value-select-filter>
